export const aboutData = {
    title: "Who I am",
    description1: "My name's Oleh. I'm a senior full stack engineer based in Lviv, Ukraine.",
    description2: "During the day I work as a professional and senior developer in the office and in the evening I try to improve my skills. I spent my leisure hours reading articles about modern techniques. Right now I'm also trying a hand at Ruby on rails and Kubernetes. I love to learn and explore new arenas. No pain, No gain!!!",
    image: 1
}